import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';

import { Popover, PopoverTrigger, PopoverContent, Button, Separator } from 'twyne-new.ui'

const propTypes = {
  id: PropTypes.string,
  target: PropTypes.object,
  placement: PropTypes.string,
  title: PropTypes.any,
}

export function ControlledConfirmationPopover({ trigger = 'legacy', target, id, title, children, placement, inline, onSubmit, ...props }) {
  id = `popconfirm-${id}`

  const [isOpen, setIsOpen] = useState(false)
  const [overrideTrigger, setOverrideTrigger] = useState(false)

  const handleToggle = useCallback(() => {
    if (overrideTrigger) {
      setOverrideTrigger(false)
      return;
    }
    setIsOpen(isOpen => !isOpen)
  }, [overrideTrigger])

  const handleSubmit = useCallback(async () => {
    await onSubmit()
    setOverrideTrigger(true)
    setIsOpen(false)
  }, [onSubmit])

  return <>
    <Popover open={isOpen} side={placement} trigger={trigger} container={inline && `#${id}` || undefined}>
      <PopoverTrigger asChild>
        <div onClick={handleToggle} {...props}>
          {target}
        </div>
      </PopoverTrigger>
      <PopoverContent onPointerDownOutside={handleToggle}>
        {title}
        <Separator className='m-0 my-2' />
        {children}
        <Button className='flex justify-center mt-2' block color="danger" onClick={handleSubmit}>
          Yes, I am sure
        </Button>
      </PopoverContent>
    </Popover>
  </>
}

export default function ConfirmationPopover({ target, id, title, children, placement, inline, contentProps, open, onOpenChange, ...props }) {
  id = `popconfirm-${id}`
  return <>
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild {...props}>
        <div>
          {target}
        </div>
      </PopoverTrigger>
      <PopoverContent side={placement} container={inline && `#${id}` || undefined} {...contentProps}>
        {title}
        <Separator className='m-0 my-2' />
        {children}
      </PopoverContent>
    </Popover>
  </>
}

ConfirmationPopover.propTypes = propTypes
ConfirmationPopover.defaultProps = {
  title: '',
  placement: 'left',
  inline: false,
}
